import type { TDatadogErrorLog } from 'utils/datadog/types'

export const SEARCH_TERRITORY_OPTIONS_LOG: TDatadogErrorLog = {
  from: 'components/DashboardModals/CreateDashboardModal/components/TerritorySelector',
  message: 'Failed to search territories',
  name: 'searchTerritoryOptions',
}
